export function LogSlider(this: any, options?: any) {
    const opts = options || {};
    this.minpos = opts.minpos || 0;
    this.maxpos = opts.maxpos || 100;
    this.minlval = Math.log(opts.minval || 1);
    this.maxlval = Math.log(opts.maxval || 100000);

    this.scale = (this.maxlval - this.minlval) / (this.maxpos - this.minpos);
}

LogSlider.prototype = {
    // Calculate value from a slider position
    value(this: any, position: number) {
        return Math.exp((position - this.minpos) * this.scale + this.minlval);
    },
    // Calculate slider position from a value
    position(this: any, value: number) {
        return this.minpos + (Math.log(value) - this.minlval) / this.scale;
    },
};
